// app_client/src/store/userStore.js
import { create } from 'zustand';
import axios from 'axios';
import useAuthStore from './authStore';

const normalizeRoleName = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .replace(/ı/g, 'i')
  .replace(/[^a-z0-9]/g, '');

const isSuperAdminRole = (user) => normalizeRoleName(user?.roleName || user?.role?.name || user?.role) === 'superadmin';

const shouldHideGhostUsers = () => !isSuperAdminRole(useAuthStore.getState().user);

const filterGhostUsers = (list = []) => {
  if (!shouldHideGhostUsers()) return Array.isArray(list) ? list : [];
  return (Array.isArray(list) ? list : []).filter((user) => !isSuperAdminRole(user));
};

const filterGhostRoles = (list = []) => {
  if (!shouldHideGhostUsers()) return Array.isArray(list) ? list : [];
  return (Array.isArray(list) ? list : []).filter((role) => normalizeRoleName(role?.name) !== 'superadmin');
};

const useUserStore = create((set, get) => ({
  users: [],
  loading: false,
  error: null,
  roles: [],

  fetchUsers: async () => {
    set({ loading: true });
    try {
      const res = await axios.get('/api/users');
      set({ users: filterGhostUsers(res.data), loading: false });
    } catch (err) {
      console.log('error', err)
      set({ error: "Kullanıcılar yüklenemedi", loading: false });
    }
  },

  fetchRoles: async () => {
    try {
      const res = await axios.get('/api/roles');
      set({ roles: filterGhostRoles(res.data) });
    } catch (err) {
      console.log('error', err)
      console.error("Roller yüklenemedi");
    }
  },

  updateUserStatus: async (id, status) => {
    try {
      await axios.put(`/api/users/${id}`, { status });
      // Local state'i güncelle (Sayfayı yenilemeden)
      set((state) => ({
        users: state.users.map(u => u._id === id ? { ...u, status } : u)
      }));
    } catch (err) {
      console.error("Durum güncellenemedi", err);
    }
  },

  saveUser: async (formData, userId = null) => {
    try {
      if (userId) {
        await axios.put(`/api/users/${userId}`, formData);
      } else {
        await axios.post('/api/users', formData);
      }
      // Veriyi tekrar çekerek listeyi tazele
      const res = await axios.get('/api/users');
      set({ users: filterGhostUsers(res.data) });
      return { success: true };
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "Hata oluştu" };
    }
  },

  deleteUser: async (id) => {
    try {
      await axios.delete(`/api/users/${id}`);
      await get().fetchUsers();
      return { success: true };
    } catch (err) {
      return { success: false, message: err.response?.data?.message || "Kullanıcı silinemedi" };
    }
  }
}));

export default useUserStore;
